import { Token } from '@uniswap/sdk-core';
import {
  Asset, NETWORK_TOKEN_ADDRESS, SelectTokenModalWrapper, Web3Context,
} from 'common-client';
import { SelectPairBox } from 'components/SelectPairBox';
import { ConfigContext } from 'config';
import React, { useContext, useMemo } from 'react';

export interface SelectPairBoxWrapperProps {
  /**
   * Prompt to display
   */
  prompt?: string;
  /**
   * Sell asset
   */
  sellAsset?: Token;
  /**
   * Callback when sell asset is updated
   */
  onSellAssetChange?: (token: Token) => void;
  /**
   * Bid asset
   */
  bidAsset?: Token;
  /**
   * Callback when bid asset is updated
   */
  onBidAssetChange?: (token: Token) => void;
  /**
   * Callback on clicking next button
   */
  onNextClick?: () => void;
}

export function SelectPairBoxWrapper({
  prompt,
  sellAsset,
  onSellAssetChange,
  bidAsset,
  onBidAssetChange,
  onNextClick,
}: SelectPairBoxWrapperProps) {
  const { chainId } = useContext(Web3Context);
  const { networkConfig } = useContext(ConfigContext);
  const [sellAssetModalOpen, setSellAssetModalOpen] = React.useState(false);
  const [bidAssetModalOpen, setBidAssetModalOpen] = React.useState(false);

  const quickTokenList: Array<Token> = useMemo(() => {
    if (networkConfig) {
      return [
        networkConfig.asset[Asset.WBTC],
        networkConfig.asset[Asset.WETH],
        networkConfig.asset[Asset.WAMPL],
        networkConfig.asset[Asset.USDT],
      ];
    }
    return [];
  }, []);
  const tokenBlockList = useMemo(() => {
    const blockList = [
      // network native tokens not supported
      new Token(chainId, NETWORK_TOKEN_ADDRESS, 0),
    ];
    // rebasing assets not supported
    if (networkConfig) {
      blockList.push(networkConfig.asset[Asset.AMPL]);
    }
    return blockList;
  }, [chainId, networkConfig]);

  return (
    <>
      <SelectPairBox
        prompt={prompt}
        sellAsset={sellAsset}
        onSellAssetClick={() => setSellAssetModalOpen(true)}
        bidAsset={bidAsset}
        onBidAssetClick={() => setBidAssetModalOpen(true)}
        onNextClick={onNextClick}
      />
      <SelectTokenModalWrapper
        open={sellAssetModalOpen}
        onClose={() => setSellAssetModalOpen(false)}
        onSelect={onSellAssetChange}
        quickTokenList={quickTokenList}
        tokenBlockList={tokenBlockList}
      />
      <SelectTokenModalWrapper
        open={bidAssetModalOpen}
        onClose={() => setBidAssetModalOpen(false)}
        onSelect={onBidAssetChange}
        quickTokenList={quickTokenList}
      />
    </>
  );
}
